import { combineReducers } from '@reduxjs/toolkit';
import decryptOfflineReadingReducer from './decrypt-offline-reading';
import uploadOfflineReadingReducer from './upload-offline-reading';
import exportNcdRiskReadingListReducer from './export-ncd-risk-reading-list';
import exportReadingListReducer from './export-reading-list';
import getNcdRiskAnalysisReducer from './get-ncd-risk-analysis';
import getNcdRiskReadingListReducer from './get-ncd-risk-reading-list';
import getReadingReducer from './get-reading';
import getReadingDateListReducer from './get-reading-date-list';
import getReadingListReducer from './get-reading-list';
import getRiskReadingListReducer from './get-risk-reading-list';
import getScreeningStatsReducer from './get-screening-stats';

const readingReducer = combineReducers({
  decryptOfflineReading: decryptOfflineReadingReducer,
  uploadOfflineReading: uploadOfflineReadingReducer,
  exportNcdRiskReadingList: exportNcdRiskReadingListReducer,
  exportReadingList: exportReadingListReducer,
  getNcdRiskAnalysis: getNcdRiskAnalysisReducer,
  getNcdRiskReadingList: getNcdRiskReadingListReducer,
  getReading: getReadingReducer,
  getReadingDateList: getReadingDateListReducer,
  getReadingList: getReadingListReducer,
  getRiskReadingList: getRiskReadingListReducer,
  getScreeningStats: getScreeningStatsReducer
});

export default readingReducer;